<script setup lang="ts">
import { DATA_TEST_IDS } from "@/constants/data-test-ids/data-test-ids.constant";

import HospitalityButton from "@/components/ui/buttons/hospitality-button.vue";

interface IProps {
  cancelLabel?: string;
  primaryLabel: string;
  primaryDisabled?: boolean;
  primaryLoading?: boolean;
}

interface IEmits {
  (e: "cancel"): void;
  (e: "submit"): void;
}

const props = withDefaults(defineProps<IProps>(), {
  cancelLabel: "Annuler",
  primaryDisabled: false,
  primaryLoading: false,
});
const emit = defineEmits<IEmits>();
</script>

<template>
  <div class="flex w-full items-center justify-between">
    <HospitalityButton
      :data-test-id="DATA_TEST_IDS.components.programEditor.cancelButton"
      :disabled="props.primaryLoading"
      severity="secondary"
      @click="emit('cancel')"
    >
      {{ props.cancelLabel }}
    </HospitalityButton>

    <HospitalityButton
      :aria-busy="props.primaryLoading"
      :data-test-id="DATA_TEST_IDS.components.programEditor.primaryActionButton"
      :disabled="props.primaryDisabled || props.primaryLoading"
      :loading="props.primaryLoading"
      @click="emit('submit')"
    >
      {{ props.primaryLabel }}
    </HospitalityButton>
  </div>
</template>
